import { clusterId, pipelineId, writekey } from '../fixture-ids';

export const pipelineEventEntries = {
  // action-proxy/control_audit.go:85-114. writekey is always present; pipelineId/pipelineName
  // are added only when the writekey lookup succeeds, so the row's key set varies row to row
  // within this one action — both parentRefs and parentValueKeys are declared so a row
  // is attached to its pipeline whichever shape it has.
  PIPELINE_DEPLOYED: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
    parentRefs: [{ key: 'pipelineId', entity: 'pipeline' }],
    parentValueKeys: [{ key: 'writekey', entity: 'pipeline', entityField: 'writekey' }],
    foreignDisplayKeys: ['pipelineName'],
  },
  AJS_FILE_BUILT: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
    parentRefs: [{ key: 'pipelineId', entity: 'pipeline' }],
    foreignDisplayKeys: ['pipelineName'],
  },
  STANDALONE_SYNC_FILE_BUILT: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
    parentRefs: [{ key: 'pipelineId', entity: 'pipeline' }],
    foreignDisplayKeys: ['pipelineName'],
  },
  // The request field is misnamed pipelineId (packages/api/control/useControlProxy.js:200
  // sends body:{pipelineId: writekey}); action-proxy reads it into a local it also calls
  // writeKey (action-proxy/control_audit.go:117) and writes the audit key correctly as a
  // writekey — hence the same entityField as PIPELINE_DEPLOYED despite the different
  // spelling. The writer is left as is; the map absorbs the misnomer.
  AJS_FILE_UPLOADED: {
    entity: null,
    identity: 'event',
    renderMode: 'keyValue',
    createsRecord: false,
    parentValueKeys: [{ key: 'writeKey', entity: 'pipeline', entityField: 'writekey' }],
  },
};

export const pipelineEventFixtures = {
  // Two fixtures for one action: the writer adds pipelineId/pipelineName only when its writekey
  // lookup succeeds, so both shapes reach the panel. They dispatch identically by construction —
  // an event entry's parentRefs and parentValueKeys feed only the scope query, never the resolver.
  PIPELINE_DEPLOYED_RESOLVED: {
    action: 'PIPELINE_DEPLOYED',
    debugData: {
      writekey,
      clusterId,
      path: '/v1.1/pipeline',
      pipelineId,
      pipelineName: 'Web Analytics',
    },
  },
  PIPELINE_DEPLOYED_WRITEKEY_ONLY: {
    action: 'PIPELINE_DEPLOYED',
    debugData: {
      writekey,
      clusterId,
      path: '/v1.1/pipeline',
    },
  },
  AJS_FILE_BUILT: {
    action: 'AJS_FILE_BUILT',
    debugData: {
      pipelineId,
      pipelineName: 'Web Analytics',
    },
  },
  STANDALONE_SYNC_FILE_BUILT: {
    action: 'STANDALONE_SYNC_FILE_BUILT',
    debugData: {
      pipelineId,
      pipelineName: 'Web Analytics',
    },
  },
  AJS_FILE_UPLOADED: {
    action: 'AJS_FILE_UPLOADED',
    debugData: {
      writeKey: writekey,
      clusterId,
      gzippedFileBase64Bytes: 48213,
      path: '/v1.1/analytics_js_file',
    },
  },
};
